
class ViewLog
{
	/** @type {PopupHelper} */
	_popupHelper = null;

	constructor()
	{
		let thisObj = this;
		this._popupHelper = new PopupHelper("#view-log-popup", {
			
		});
	}

	open(endpoint)
	{
		this._popupHelper.open();
		let popupHelper = this._popupHelper;
		popupHelper.showLoading();
		dataAction.callClientGetEndpoint(
			endpoint,
			function (response)
			{
				popupHelper.setContent(response);
				// showSuccessPopup(response, mvvm.reset);
			},
			popupHelper.defaultResponseErrorHandler.bind(popupHelper),
			popupHelper.hideLoading.bind(popupHelper)
		);
	}
}